// import { configureStore } from "@reduxjs/toolkit";
// import districtReducer from "../../components/filter/districtDetailsFilter/store";
// import menuReducer from "../../layouts/store";
// import TimeReducer from "../../components/filter/durationFilter/store";
// import applicationStatusReducer from "../../components/applicationStatus/store";
// import ruralDetailsCountReducer from "../../components/ruralDetailsCount/store";
// import stateDetailsReducer from "../../components/filter/stateDetailsFilter/store";
// import dashboardReducer from "../../pages/dashboard/store";

//  const store = configureStore({
//   reducer: {
//     district: districtReducer,
//     menu: menuReducer,
//     time: TimeReducer,
//     applicationStatus: applicationStatusReducer,
//     dynamicData: ruralDetailsCountReducer,
//     stateDetails: stateDetailsReducer,
//     chartListDetails: dashboardReducer,
//   },
// });

// export default store






import { combineReducers } from "@reduxjs/toolkit";
import districtReducer from "../../components/filter/districtDetailsFilter/store";
import menuReducer from "../../layouts/store";
import TimeReducer from "../../components/filter/durationFilter/store";
import applicationStatusReducer from "../../components/applicationStatus/store";
import ruralDetailsCountReducer from "../../components/ruralDetailsCount/store";
import stateDetailsReducer from "../../components/filter/stateDetailsFilter/store";
import dashboardReducer from "../../pages/dashboard/store";

const rootReducer = combineReducers({
  district: districtReducer,
  menu: menuReducer,
  time: TimeReducer,
  applicationStatus: applicationStatusReducer,
  dynamicData: ruralDetailsCountReducer,
  stateDetails: stateDetailsReducer,
  chartListDetails: dashboardReducer,
});

export default rootReducer; // ✅ must be default export (a function)

